import React from 'react'

const FILTER_OPTIONS = [
  { value: 'all', label: 'Pending' },
  { value: 'deferred', label: 'Deferred' },
]

export const Filters = ({ activeFilter, search, onFilterChange, onSearchChange }) => {
  return (
    <div className="mb-3">
      <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
        <div className="btn-group mr-3" role="group">
          {FILTER_OPTIONS.map(opt => (
            <button
              key={opt.value}
              type="button"
              className={`btn btn-sm btn-myed ${activeFilter === opt.value ? 'btn-primary btn-primary-myed' : 'btn-default btn-default-myed'}`}
              onClick={() => onFilterChange(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>

        <div className="input-group input-group-sm" style={{ maxWidth: '300px' }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search by title or course #"
            value={search}
            onChange={e => onSearchChange(e.target.value)}
          />
          {search && (
            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => onSearchChange('')}
              >
                <i className="fa-regular fa-times" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
